// Shared shell for the four Account sections, so they line up with the rest of
// the detail screens (Clients, Vendors, Project Finances).
// `large` is for the first section on a page, matching the page headings.
export const Section = ({ title, children, actions, large = false }) => (
  <section>
    <div className="mb-3 flex flex-wrap items-center justify-between gap-3">
      <h2
        className={
          large
            ? "text-[22px] font-semibold tracking-tight text-gray-900"
            : "text-xs font-semibold text-gray-500 uppercase tracking-wider"
        }
      >
        {title}
      </h2>
      {actions && <div className="flex items-center gap-2 text-sm">{actions}</div>}
    </div>
    {children}
  </section>
);

export const Card = ({ children, className = "" }) => (
  <div
    className={`rounded-lg border border-gray-100 bg-white p-5 shadow-sm ${className}`}
  >
    {children}
  </div>
);

export const FieldGrid = ({ children }) => (
  <div className="grid grid-cols-1 gap-x-8 gap-y-3 md:grid-cols-2">{children}</div>
);

export const Field = ({ label, value }) => {
  const isEmpty = value === null || value === undefined || value === "";
  return (
    <div className="flex items-start text-sm">
      <span className="w-52 shrink-0 pt-px text-xs font-medium text-gray-500">
        {label}:
      </span>
      <span className="min-w-0 break-words text-gray-900">{isEmpty ? "—" : value}</span>
    </div>
  );
};
